import { motion } from "framer-motion";
import { useLanguage } from "@/i18n/LanguageContext";

const QUOTE_ACCENTS = ["#E6007E", "#00A6E6"];

export default function Testimonials() {
  const { t, lang } = useLanguage();
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-32 md:py-40 border-t border-white/5"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-20 max-w-2xl">
          <p className="text-xs tracking-[0.22em] uppercase text-[#F7941D] mb-4">{t.testimonials.kicker}</p>
          <h2 className="font-display text-4xl md:text-6xl font-light tracking-tighter text-balance">
            {lang === "ar" ? (
              <>الناشرون والشركاء <span className="italic">متفقون</span>.</>
            ) : (
              <>Publishers &amp; partners <span className="italic">agree</span>.</>
            )}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {t.testimonials.quotes.map((q, i) => (
            <motion.blockquote
              key={q.who}
              initial={{ y: 30, opacity: 0 }}
              whileInView={{ y: 0, opacity: 1 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="relative overflow-hidden rounded-3xl border border-white/10 bg-zinc-900/40 p-8 md:p-12"
            >
              <span
                className="absolute -top-8 -right-2 font-display text-[240px] leading-none opacity-[0.06] pointer-events-none select-none"
                style={{ color: QUOTE_ACCENTS[i] }}
              >
                &ldquo;
              </span>

              <div className="relative space-y-4">
                {q.paragraphs.map((p, pi) => (
                  <p
                    key={pi}
                    className="font-display text-base md:text-lg font-light leading-relaxed text-zinc-100"
                  >
                    &ldquo;{p}&rdquo;
                  </p>
                ))}
                <footer className="pt-4 mt-6 border-t border-white/10 flex items-center gap-4">
                  <div
                    className="h-10 w-10 rounded-full shrink-0"
                    style={{
                      background: `linear-gradient(135deg, ${QUOTE_ACCENTS[i]}, ${QUOTE_ACCENTS[i]}66)`,
                    }}
                  />
                  <div>
                    <p className="text-sm text-zinc-100">{q.who}</p>
                    <p className="text-xs text-zinc-500">{q.role}</p>
                  </div>
                </footer>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
